import createIcon from '../../createIcon';

/**
 * @component @name BorderTop
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyMUg5VjE5SDdWMjFaTTcgMTNIOVYxMUg3VjEzWk0xMSAxM0gxM1YxMUgxMVYxM1pNMTEgMjFIMTNWMTlIMTFWMjFaTTMgMTdINVYxNUgzVjE3Wk0zIDIxSDVWMTlIM1YyMVpNMyAxM0g1VjExSDNWMTNaTTMgOUg1VjdIM1Y5Wk0xMSAxN0gxM1YxNUgxMVYxN1pNMTkgOUgyMVY3SDE5VjlaTTE5IDEzSDIxVjExSDE5VjEzWk0zIDNWNUgyMVYzSDNaTTE5IDE3SDIxVjE1SDE5VjE3Wk0xNSAyMUgxN1YxOUgxNVYyMVpNMTEgOUgxM1Y3SDExVjlaTTE5IDIxSDIxVjE5SDE5VjIxWk0xNSAxM0gxN1YxMUgxNVYxM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderTop = createIcon('BorderTop', [
  [
    'path',
    {
      d: 'M7 21H9V19H7V21ZM7 13H9V11H7V13ZM11 13H13V11H11V13ZM11 21H13V19H11V21ZM3 17H5V15H3V17ZM3 21H5V19H3V21ZM3 13H5V11H3V13ZM3 9H5V7H3V9ZM11 17H13V15H11V17ZM19 9H21V7H19V9ZM19 13H21V11H19V13ZM3 3V5H21V3H3ZM19 17H21V15H19V17ZM15 21H17V19H15V21ZM11 9H13V7H11V9ZM19 21H21V19H19V21ZM15 13H17V11H15V13Z',
      key: 'omlpa6',
    },
  ],
]);

export default BorderTop;
